'use strict';

/**
 * Model for a contact
 *
 * @category   Model
 * @module     community
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Model = require('base/Colido.Model');

var ContactModel = Model.extend({
    api: '/community/contacts',

    defaults: function(){ //use function, cause objects are passed by reference
        return {
            userId: null, //Integer
            name: '', //String
            profilePicture: null, //String
            accepted: '', //String
            conversationId: null, //Integer
            countryCode: null, //String
        };
    },

    customAttributes: {
        conversation: function() {
            return App.CommunityModule.conversationsCollection.get(this.get('conversationId'));
        },

        conversationUrl: function() {
            return '/community/contacts/conversation/' + this.get('conversationId');
        },

        conversationLastMessage: function() {
            var conversation = this.get('conversation');

            return conversation ? conversation.get('lastMessage') ? conversation.get('lastMessage') : ''
                                : '';
        },
    },
});

module.exports = ContactModel;